import get from 'lodash/get';
import { isPlatform } from '@ionic/core';
import BackgroundGeolocation from 'cordova-background-geolocation';

import {
  getNotificationTimeEntries,
  updateNotificationLog,
} from '../../store/notificationLog';
import {
  getNotificationTitle,
  meetFrequencyCriteria,
  openNotification,
  requestPermissionNotification,
} from '../../util/notifications';
import { GEO_DEBUG } from './util';

const onGeofenceCrossing = eventParams => {
  GEO_DEBUG && console.log('*SJD [onGeofence]: ', eventParams);
  if (
    eventParams.action === 'DWELL' ||
    (GEO_DEBUG && eventParams.action === 'ENTER')
  ) {
    const notificationTemplate = get(eventParams, [
      'extras',
      'notificationTemplate',
    ]);

    getNotificationTimeEntries(notificationTemplate.id)
      .then(notificationTimeEntries => {
        if (
          meetFrequencyCriteria({
            timeEntries: notificationTimeEntries,
            template: notificationTemplate,
          })
        ) {
          updateNotificationLog(notificationTemplate.id);
          openNotification({
            title: getNotificationTitle(notificationTemplate.locationTypeId),
            body: notificationTemplate.text,
            id: notificationTemplate.id,
          });
        }
      })
      .catch(err => console.log('[ERROR]:', err));
  }
};

const geolocationHeadlessTask = async event => {
  const { name, params } = event;
  if (name === 'geofence') {
    onGeofenceCrossing(params);
  }
};

export const registerHeadlessBackgroundGeolocationTaskIfMobile = () => {
  GEO_DEBUG &&
    console.log('*DTA registerHeadlessBackgroundGeolocationTaskIfMobile()');
  if (isPlatform('android') || isPlatform('ios')) {
    GEO_DEBUG &&
      console.log(
        '*DTA registerHeadlessBackgroundGeolocationTaskIfMobile(): REGISTERED ON MOBILE!',
      );

    requestPermissionNotification();
    BackgroundGeolocation.registerHeadlessTask(geolocationHeadlessTask);
    BackgroundGeolocation.onGeofence(onGeofenceCrossing);
  }
};



// WEBPACK FOOTER //
// ./src/modules/Geolocation/registerHeadlessBackgroundGeolocationTaskIfMobile.js